import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import "./SignUpPage.scss";
import { Link } from "react-router-dom";

export const Conditions = ({ onTermsAccepted, onCloseTearms }) => {

  const [close, setClose] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    const element = document.getElementById('top');
    onCloseTearms(close);
    element.scrollIntoView();
  }, [onCloseTearms, close]);

  const handleClick = () => {
    setClose(!close);
    setIsChecked(true)

  };

  useEffect(() => {
    onTermsAccepted(isChecked);
  }, [onTermsAccepted, isChecked])



  return (
    <div className="first-access-data-protection px-xl-4 container">
      <div>
        <h1 className="mb-4" id="top">
           Términos y condiciones de contratación del producto eGrade
        </h1>
        <h6 className="text-start mb-4">
          <strong>I. AVISO LEGAL</strong>
        </h6>
        <p className="mb-4">
          Solunion Servicios de Crédito S.L (responsable del sitio web, en adelante
          Solunion), pone a disposición de los usuarios el presente documento, con el
          que pretende dar cumplimiento a las obligaciones dispuestas en la Ley
          34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y
          del Comercio Electrónico (LSSICE), así como informar a todos los usuarios
          del sitio web respecto a cuáles son las condiciones de uso.
        </p>
        <p className="mb-4">
          Este es un servicio dirigido de manera exclusiva a empresas. Las personas físicas que
          accedan deberán hacerlo en el marco de su actividad profesional, como autónomos.
        </p>
        <p className="mb-4">
          Toda persona y/ o empresa que acceda a este sitio web asume el papel de
          usuario, comprometiéndose a la observancia y cumplimiento riguroso de las
          disposiciones aquí dispuestas, así como a cualquier otra disposición legal
          que fuera de aplicación.
        </p>
        <p className="mb-4">
          Solunion Servicios de Crédito S.L se reserva el derecho de modificar
          cualquier tipo de información que pudiera aparecer en el sitio web, sin que
          exista obligación de preavisar o poner en conocimiento de los usuarios
          dichas obligaciones, entendiéndose como suficiente con la publicación en el
          sitio web de Solunion Servicios de Crédito S.
        </p>

        <h6 className="mb-4">
          <strong>II.
            OBJETO</strong>
        </h6>
        <p className="mb-4">
          A través del Sitio Web, les ofrecemos a los Usuarios la posibilidad de
          obtener la valoración de crédito de una empresa, de forma inmediata y 100%
          online. Una herramienta que apoya a la gestión del riesgo de tu actividad y
          que te permite conocer la calificación de más de 40 millones de empresas en
          todo el mundo en función de la probabilidad de impago que presenten
          (Grade). Esta valoración se expresa en una escala del 1 al 10, de mejor a
          peor, y determina la probabilidad de impago de una empresa.    <strong> </strong>
        </p>
        <h6 className="mb-4 text-start">
          <p>PRIVACIDAD Y TRATAMIENTO DE DATOS</p>
        </h6>
        <p className="mb-4">
          El Usuario y SOLUNION se responsabilizan respectivamente de cumplir en
          debida forma con las previsiones contenidas en el Reglamento (UE) 2016/679
          del Parlamento Europeo y del Consejo de 27 de abril de 2016 relativo a la
          protección de las personas físicas en lo que respecta al tratamiento de
          datos personales y a la libre circulación de estos datos y por el que se
          deroga la Directiva 95/46/CE (Reglamento general de protección de datos
          -RGPD-) y con las igualmente recogidas en la Ley Orgánica 3/2018, de 5 de
          diciembre, de Protección de Datos Personales y garantía de los derechos
          digitales (LOPDGDD).
        </p>
        <p className="mb-4">
          Para más información, puede consultar nuestra
          <Link className=" ms-2" to="/privacity">
            Política de Privacidad.
          </Link>


        </p>
        <h6 className="mb-4 text-start">
          <strong>III.
            PROPIEDAD INDUSTRIAL E INTELECTUAL</strong>
        </h6>
        <p className="mb-4">
          El Usuario reconoce que todos los elementos de Servicio Web, y cada uno de
          los servicios prestados a través del mismo, la información y materiales
          contenidos en el mismo, estructura, selección, ordenación y presentación de
          sus contenidos y los programas de ordenador utilizados en relación con el
          mismo están protegidos por derechos de propiedad intelectual e industrial
          de SOLUNION, directamente o mediante la licencia de terceros.
        </p>
        <p className="mb-4">
          Salvo que fuera autorizado por SOLUNION, o a menos que resulte legalmente
          permitido, el Usuario no podrá reproducir, transformar, modificar,
          desensamblar, realizar ingeniería inversa, distribuir, alquilar, prestar,
          poner a disposición o permitir el acceso al público o a terceros no
          autorizados a través de cualquier modalidad de comunicación pública de
          ninguno de los elementos referidos en el párrafo anterior.
        </p>
        <p className="mb-4">
          En particular, queda terminantemente prohibida la utilización de los
          textos, imágenes, anuncios y cualquier otro elemento incluido en la
          presente Sitio Web para su posterior inclusión, total o parcial, en otros
          sitios web ajenos sin contar con la previa autorización escrita de
          SOLUNION.
        </p>
        <p className="mb-4">
          El Usuario deberá utilizar los materiales, elementos e información a la que
          acceda a través de la utilización de la Sitio Web únicamente con el
          propósito de obtener una valoración de crédito de una empresa, obligándose
          a no realizar directa ni indirectamente una explotación comercial ni de los
          servicios ni de los materiales, elementos e información obtenidos a través
          de los mismos, excepto lo indicado en la presente.
        </p>
        <p className="mb-4">
          El Usuario deberá abstenerse de suprimir los signos identificativos de los
          derechos de propiedad intelectual o industrial de SOLUNION o de terceros
          que figuren en ella.
        </p>
        <p className="mb-4 text-start">
          <strong>IV. </strong>
          <strong>OBLIGACIONES Y RESPONSABILIDADES DEL USUARIO DEL SITIO WEB</strong>
        </p>
        <p className="mb-4">
          El Usuario se compromete a:
        </p>
        <ol className="mb-4" start="1" type="1">
          <li>
            Hacer un uso adecuado y lícito del Sitio Web así como de los contenidos
            y servicios, de conformidad con: (i) la legislación aplicable en cada
            momento; (ii) las Condiciones Generales de Uso del Sitio Web; (iii) la
            moral y buenas costumbres generalmente aceptadas y (iv) el orden
            público.
          </li>
          <li>
            Proveerse de todos los medios y requerimientos técnicos que se precisen
            para acceder al Sitio Web.
          </li>
          <li>
            Facilitar información veraz al cumplimentar con sus datos de carácter
            personal los formularios contenidos en el Sitio Web y a mantenerlos
            actualizados en todo momento de forma que responda, en cada momento, a
            la situación real del Usuario. El Usuario será el único responsable de
            las manifestaciones falsas o inexactas que realice y de los perjuicios
            que cause a la empresa o a terceros por la información que facilite.
          </li>
        </ol>
        <p>
          No obstante, lo establecido en el apartado anterior el Usuario deberá
          asimismo abstenerse de:
        </p>
        <ol className="mb-4" start="1" type="1">
          <li>
            Hacer un uso no autorizado o fraudulento del Sitio Web y/o de los
            contenidos con fines o efectos ilícitos, prohibidos en las presentes
            Condiciones Generales de Uso, lesivos de los derechos e intereses de
            terceros, o que de cualquier forma puedan dañar, inutilizar,
            sobrecargar, deteriorar o impedir la normal utilización de los
            servicios o los documentos, archivos y toda clase de contenidos
            almacenados en cualquier equipo informático.
          </li>
          <li>
            Acceder o intentar acceder a recursos o áreas restringidas del Sitio
            Web, sin cumplir las condiciones exigidas para dicho acceso.
          </li>
          <li>
            Provocar daños en los sistemas físicos o lógicos del Sitio Web, de sus
            proveedores o de terceros.
          </li>
          <li>
            Introducir o difundir en la red virus informáticos o cualesquiera otros
            sistemas físicos o lógicos que sean susceptibles de provocar daños en
            los sistemas físicos o lógicos de la empresa, proveedores o de
            terceros.
          </li>
          <li>
            Intentar acceder, utilizar y/o manipular los datos de la empresa,
            terceros proveedores y otros Usuarios.
          </li>
          <li>
            Reproducir o copiar, distribuir, permitir el acceso del público a
            través de cualquier modalidad de comunicación pública, transformar o
            modificar los contenidos, a menos que se cuente con la autorización del
            titular de los correspondientes derechos o ello resulte legalmente
            permitido.
          </li>
          <li>
            Suprimir, ocultar o manipular las notas sobre derechos de propiedad
            intelectual o industrial y demás datos identificativos de los derechos
            de la empresa o de terceros incorporados a los contenidos, así como los
            dispositivos técnicos de protección o cualesquiera mecanismos de
            información que puedan insertarse en los contenidos.
          </li>
          <li>
            Obtener e intentar obtener los contenidos empleando para ello medios o
            procedimientos distintos de los que, según los casos, se hayan puesto a
            su disposición a este efecto o se hayan indicado expresamente en las
            páginas web donde se encuentren los contenidos o, en general, de los
            que se empleen habitualmente en Internet por no entrañar un riesgo de
            daño o inutilización del Sitio web y/o de los contenidos.
          </li>
          <li>
            En particular, y a título meramente indicativo y no exhaustivo, el
            Usuario se compromete a no transmitir, difundir o poner a disposición
            de terceros informaciones, datos, contenidos, mensajes, gráficos,
            dibujos, archivos de sonido y/o imagen, fotografías, grabaciones,
            software y, en general, cualquier clase de material que: • De cualquier
            forma sea contrario, menosprecie o atente contra los derechos
            fundamentales y las libertades públicas reconocidas
            constitucionalmente, en los Tratados Internacionales y en el resto de
            la legislación vigente.• Induzca, incite o promueva actuaciones
            delictivas, denigratorias, difamatorias, violentas o, en general,
            contrarias a la ley, a la moral, a las buenas costumbres generalmente
            aceptadas o al orden público.• Induzca, incite o promueva actuaciones,
            actitudes o pensamientos discriminatorios por razón de sexo, raza,
            religión, creencias, edad o condición.• Incorpore, ponga a disposición
            o permita acceder a productos, elementos, mensajes y/o servicios
            delictivos, violentos, ofensivos, nocivos, degradantes o, en general,
            contrarios a la ley, a la moral y a las buenas costumbres generalmente
            aceptadas o al orden público. Induzca o pueda inducir a un estado
            inaceptable de ansiedad o temor.• Induzca o incite a involucrarse en
            prácticas peligrosas, de riesgo o nocivas para la salud y el equilibrio
            psíquico.• Se encuentra protegido por la legislación en materia de
            protección intelectual o industrial perteneciente a Solunion o a
            terceros sin que haya sido autorizado el uso que se pretenda realizar.•
            Sea contrario al honor, a la intimidad personal y familiar o a la
            propia imagen de las personas.• Constituya cualquier tipo de
            publicidad.• Incluya cualquier tipo de virus o programa que impida el
            normal funcionamiento del Sitio Web.
          </li>
        </ol>
        <p className="mb-4">
          Si para acceder a algunos de los servicios y/o contenidos del Sitio Web, se
          le proporcionara una contraseña, se obliga a usarla de manera diligente,
          manteniéndola en todo momento en secreto. En consecuencia, será responsable
          de su adecuada custodia y confidencialidad, comprometiéndose a no cederla a
          terceros, de manera temporal o permanente, ni a permitir el acceso a los
          mencionados servicios y/o contenidos por parte de personas ajenas.
          Igualmente, se obliga a notificar a la sociedad cualquier hecho que pueda
          suponer un uso indebido de su contraseña, como, a título enunciativo, su
          robo, extravío o el acceso no autorizado, con el fin de proceder a su
          inmediata cancelación. En consecuencia, mientras no efectúe la notificación
          anterior, la empresa quedará eximida de cualquier responsabilidad que
          pudiera derivarse del uso indebido de su contraseña, siendo de su
          responsabilidad cualquier utilización ilícita de los contenidos y/o
          servicios del Sitio Web por cualquier tercero ilegítimo. Si de manera
          negligente o dolosa incumpliera cualquiera de las obligaciones establecidas
          en las presentes Condiciones Generales de Uso, responderá por todos los
          daños y perjuicios que de dicho incumplimiento pudieran derivarse para la
          empresa.
        </p>
        <h6>
          <strong>V.
            RESPONSABILIDADES</strong>
        </h6>
        <p className="mb-4">
          SOLUNION, bajo ninguna circunstancia, será responsable por daños indirectos
          tales como cualquier perjuicio financiero o comercial, pérdida de
          beneficio, problemas de negocio, pérdidas de ingresos, acciones legales
          emprendidas por el Usuario por el uso de nuestra web y app o cualquier
          información encontrada en la misma.
        </p>
        <p className="mb-4">
          El Usuario asume las consecuencias de cualquier clase que se pudieran
          derivar de un mal uso de la Sitio Web, dejando absolutamente indemne a
          SOLUNION. SOLUNION no responde de la veracidad y exactitud de la
          información procedente de terceros ajenos a ella ni de los contenidos a los
          que el Usuario pueda acceder mediante los links o enlaces a páginas web de
          terceros que se incluyen en la página.
        </p>
        <p className="mb-4">
          SOLUNION no garantiza al usuario la disponibilidad, acceso o continuidad en
          la conexión al sitio web y app, y en el suministro de información o
          cualquiera de los distintos servicios ofrecidos a través del mismo. En
          consecuencia, SOLUNION y cualquier posible proveedor de contenidos no serán
          responsables en caso de que existan interrupciones del servicio, demoras,
          mal funcionamiento, y en general, cualquier inconveniente que tenga su
          origen en causas que escapan del control de SOLUNION o de los proveedores,
          o provenga de una actuación dolosa o culposa del usuario, o fuerza mayor.
        </p>
        <p className="mb-4">
          SOLUNION tampoco garantiza la utilidad, obtención de resultados o
          infalibilidad de los contenidos facilitados a través del web y de la app,
          que en todo caso lo son con carácter orientativo e informativo.
        </p>
        <p className="mb-4">
          Dicha información se ha obtenido de fuentes consideradas razonablemente
          fiables, pero no deben presumirse en todo caso infalibles, debiendo en su
          caso ser contrastados con otras fuentes, anteriormente a adoptar cualquier
          estado de opinión o decisión por parte del usuario.
        </p>
        <p className="mb-4">
          Cuantas opiniones, medidas o actuaciones de inversión o de cualquier otro
          tipo sean adoptadas por el usuario, lo serán de su exclusiva cuenta y
          riesgo.
        </p>
        <p className="mb-4">
          SOLUNION no asume ninguna responsabilidad derivada de la utilización por
          parte del Usuario de los contenidos de esta Sitio Web a través de las
          distintas vías de acceso, reservándose el derecho a modificar, sustituir,
          actualizar, renovar, impedir el acceso, interrumpir, bloquear, suspender
          temporalmente o cancelar con carácter definitivo cualquier servicio,
          suministro de información o cualquier otro contenido, ya sea con relación a
          un usuario concreto o en general.
        </p>
        <p className="mb-4">
          Salvo que se establezca expresamente lo contrario en cada caso, SOLUNION no
          interviene, participa, ni asume garantía alguna con relación a los
          servicios o productos ofrecidos por terceros proveedores accesibles
          mediante hiperenlaces o marcos publicitarios.
        </p>
        <p className="mb-4">
          SOLUNION no asume ninguna responsabilidad por los daños que puedan causarse
          en los equipos de los usuarios por posibles virus informáticos contraídos
          por el usuario a causa de su navegación por la Sitio Web por cualquiera de
          sus vías de acceso, o por cualquier otro derivado de su navegación.
        </p>
        <p className="mb-4">
          El usuario deberá observar todas las normas, condiciones y medidas de
          seguridad adecuadas. En este sentido, se obliga a indemnizar frente a
          cualesquiera daños y perjuicios, que se deriven del uso por su parte de
          “robots”, “spiders”, “crawlers” o herramientas similares empleadas con el
          fin de recabar o extraer datos o de cualquier otra actuación por su parte
          que imponga una carga irrazonable sobre el funcionamiento del Sitio Web.
        </p>
        <p className="mb-4">
          <strong>VI. </strong>
          <strong>PROTECCIÓN DE DATOS</strong>
        </p>
        <p className="mb-4">
          El Usuario y SOLUNION se responsabilizan respectivamente de cumplir en
          debida forma con las previsiones contenidas en el Reglamento (UE) 2016/679
          del Parlamento Europeo y del Consejo de 27 de abril de 2016 relativo a la
          protección de las personas físicas en lo que respecta al tratamiento de
          datos personales y a la libre circulación de estos datos y por el que se
          deroga la Directiva 95/46/CE (Reglamento general de protección de datos
          RGPD-) y con las igualmente recogidas en la Ley Orgánica 3/2018, de 5 de
          diciembre, de Protección de Datos Personales y garantía de los derechos
          digitales (LOPDGDD).
        </p>
        <p className="mb-4">
          Para más información, puede consultar nuestra
          <Link className=" ms-2" to="/privacity">
            Política de Privacidad.
          </Link>
        </p>
        <h6 className="mb-4">
          <strong>VII.
            COOKIES</strong>
        </h6>
        <p className="mb-4">
          Este sitio utiliza cookies, pequeños ficheros que se generan en el
          ordenador, tablet y móvil del Usuario y que permiten conocer la información
          a efectos meramente estadísticos, tales como frecuencia de visita, tiempos
          de acceso, o contenidos más seleccionados.
        </p>
        <p className="mb-4">
          Las cookies están relacionadas con un Usuario anónimo y no permiten el
          acceso a los datos personales ni al disco duro, aunque el usuario tiene la
          opción de impedir su generación a través de las opciones de configuración
          de su navegador.
        </p>
        <p className="mb-4">
          El acceso del usuario a la plataforma por vía web o app implica
          autorización para obtener y procesar información que se genera como
          consecuencia de su uso, en los términos indicados, con el único fin de
          proporcionarle navegación más personalizada.
        </p>
        <p className="mb-4">
          <strong>VIII. </strong>
          <strong>DURACIÓN Y TERMINACIÓN</strong>
        </p>
        <p className="mb-4">
          La prestación de los servicios contenidos en la plataforma tiene una
          duración indefinida. Sin perjuicio de lo anterior, SOLUNION está facultada
          para dar por terminada, suspender o interrumpir unilateralmente, en
          cualquier momento y sin necesidad de preaviso, la prestación del servicio
          de la plataforma y cualesquiera servicios.
        </p>
        <p className="mb-4">
          <strong>IX. </strong>
          <strong>LEY Y JURIDICCIÓN</strong>
        </p>
        <p className="mb-4">
          Todas las cuestiones relativas a las presentes Condiciones se rigen por las
          leyes españolas y se someten a la jurisdicción de los Juzgados y Tribunales
          de Madrid.
        </p>
        <h6 className="mb-4">
          <strong>X.
            XI. INFORMACIÓN GENERAL</strong>
        </h6>
        <p className="mb-4">
          Solunion Servicios de Crédito, S.L.U. es una entidad de nacionalidad
          española, perteneciente al Grupo Solunion, con domicilio social en 28020
          Madrid (España), Avenida del General Perón, n.º 40, con la que puede
          contactar mediante el teléfono número

          (+34) 91 581 34 00, el fax número (+34) 91 581 51 46, o el correo
          electrónico

          <a className="ms-2" href="mailto:cys@solunion.com">cys@solunion.com</a>
          .
        </p>
        <p className="mb-4">
          Está inscrita en el Registro Mercantil de Madrid, Tomo 10.962, Folio 89,
          Hoja nº M-172970, Inscripción 1ª, y dispone del NIF número B81419442.
        </p>
      </div>
      <div className="first-access-data-protection-buttons pt-5 ">
        <div>
          <Button onClick={handleClick} className="first-access-data-protection-button" text="Aceptar y volver">Aceptar y volver</Button>
        </div>
      </div>
    </div>
  )
}